<template>
    <div>
        <div>{{$t("dashboard.health.performance")}}</div>
        <el-table :data="data" style="flex: 1" height="650">
            <el-table-column prop="healthScore" :label="$t('dashboard.healthScore')" width="150px">
                <template slot-scope="scope">
                    <span>
                        <em class="color-box" v-bind:style="{
                            'background-color': scope.row.color,
                        }"></em>
                        %{{ (scope.row.score * 100).toFixed(0) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="point" :label="$t('dashboard.pointPath')">
                <template slot-scope="scope">
                    <router-link :to="{
                        name: 'measurement',
                        params: { id: scope.row.lastMeasurement },
                    }"> {{ scope.row.point }}
                    </router-link>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>

import axios from 'axios';
import colorLib from '../../util/colorLib';
import treeHelper from '../../util/treeHelper';
import {mapState} from "vuex"
export default {
    name: "PointHealthPerformance",
    data() {
        return {
            data: [
            ],
        };

    },
    methods: {
        async loadData() {
            var urlString = `${process.env.VUE_APP_APIURL}/dashboard/point-health-score`;
            let resp = await axios
                .get(urlString);
            if (resp.status == 200) {
                this.data = resp.data.map(d => {
                    return {
                        color: colorLib.getRiskColor(d.healthScore*100),
                        point: treeHelper.pointIdToPath(this.flatTree,d.point),
                        score: d.healthScore,
                        lastMeasurement: d.lastMeasurement,
                    };
                });
            }
            else {
                console.log("Error loading data");
            }

        }
    },
    computed:{
        ...mapState("tree",["flatTree"])
    },
    mounted() {
        this.loadData();
    }
}

</script>
<style>
.color-box {
    width: 10px;
    height: 10px;
    display: inline-block;
}
</style>